export const CHALLENGES_CODE = [
    'Career coaching',
    'Personal development planning',
    'Startup advice',
    'Mental health advice',
    'Exam prep',
    'Resume craving',
    'Interview coaching',
    'Professional upskilling',
    'Life coaching',
    'Performance coaching',
    'Relationship coaching',
    'Sales coaching',
    'Employee coaching',
    'Success coaching',
    'Transformational coaching',
    'Wellness coaching',
    'Executive coaching',
    'Leadership coaching',
    'Financial coaching',
    'Spiritual coaching',
]